import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import { App } from './App';
import { bootTelegram } from './lib/telegram';
import { bootViewport } from './lib/viewport';
import { bootTheme } from './lib/theme';
import { refreshMoneyViews } from './lib/api';
import { retryRead } from './lib/errors';
import './styles.css';

bootTelegram();
bootTheme();
bootViewport();

// EVERY successful mutation refreshes every money view, globally (operator,
// 2 Sept: a posted 2,00,900 still showed the old balance on the next ticket —
// "why this lag? make it swift & immediate"). The ledger answers instantly;
// only the cache lagged. One hook here means no screen can ever forget.
const queryClient: QueryClient = new QueryClient({
  // Coming back to the tab re-reads the books (operator, 2 Sept: "screen not
  // updating instantly"); one retry covers a dropped tunnel packet — not a read that already waited out its whole bound (lib/errors.ts retryRead).
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: true, retry: retryRead },
    // A change to the books is sent when he taps, or fails then, in words — never paused offline to fire by itself
    // on reconnect, minutes later, after he has tapped again (Screens, 23 Oct 2026). Reads still pause: the
    // screens' "No connection" lines read that state.
    mutations: { networkMode: 'always' },
  },
  mutationCache: new MutationCache({
    onSuccess: () => refreshMoneyViews(queryClient),
  }),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
